<template>
  <div id="publishing-special-issue-add">
    <div class="ipub-h1 mar-b-20">{{this.params.id?'Special Issue Details':'Add Special Issue'}}</div>
    <ipub-form ref="special-issue-add-form"
               :model="params"
               autocomplete="off"
               :rules="rules">

      <div class="flex ipub-p2 mar-b-20">
        <span class="fw-bd">Show on Journal Website <font class="key-color">*</font></span>
        <ipub-radio-group v-model="params.showed"
                          class="mar-l-20 flex">
          <ipub-radio :value="false"
                      class="ipub-p2 mar-b-16 flex">
            <span>According to the Journal Setting</span>
          </ipub-radio>
          <ipub-radio :value="true"
                      class="ipub-p2 mar-b-16 flex mar-l-20">
            <span>Show</span>
          </ipub-radio>
        </ipub-radio-group>
      </div>
      <ipub-row :gutter="20">
        <ipub-col :span="isApp?6:3">
          <ipub-form-item prop="journalId"
                          label="Journal">
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         disabled
                         :options="journalList" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="isApp?6:3">
          <ipub-form-item prop="sort"
                          label="Hierarchy">
            <ipub-input placeholder="Enter Hierarchy"
                        number
                        v-model.trim="params.sort" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6"
                  v-if="!isApp">
          <ipub-form-item prop="code"
                          label="Website Abbreviation">
            <ipub-input placeholder="Enter Abbreviation to create unique URL"
                        v-model.trim="params.code" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="startTime"
                          label="Start Time">
            <ipub-date-picker placeholder="Select Special Issue Start Time"
                              v-model="params.startTime" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="endTime"
                          label="Deadline">
            <ipub-date-picker placeholder="Select submission deadline"
                              v-model="params.endTime" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-form-item prop="title"
                      label="Special Issue Title">
        <ipub-editor :height="150"
                     placeholder="Enter special issue title here…"
                     v-model="params.title" />
      </ipub-form-item>
      <ipub-form-item prop="summary"
                      label="Special Issue Information">
        <ipub-editor :height="300"
                     v-model="params.summary" />
      </ipub-form-item>
      <ipub-form-item prop="summary"
                      label="Custom Content Note">
        <ipub-editor :height="300"
                     v-model="params.note" />
      </ipub-form-item>

      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="categoryIdList"
                          label="Section">
            <ipub-select placeholder="Select section"
                         :options="categoryList"
                         :tree="false"
                         optionKey="id"
                         v-model="params.sectionId" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="flyer">
            <div class="ipub-p2 fw-bd mar-b-10 relative"
                 slot="label">
              Special Issue Flyer
              <ipub-tooltip placement="right"
                            type="dark"
                            class="mar-l-10">
                <div slot="title">PDF</div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
            </div>
            <ipub-upload-input :file="params"
                               _name="flyerName"
                               _path="flyer"
                               class="mar-b-20"
                               :domain="domain"
                               @delete="delFile('flyer')"
                               @change="(e)=>{handleUpload('flyer', e)}" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-form-item label="Keywords"
                      prop="keywords">
        <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                    tag
                    v-model.trim="params.keywords" />
      </ipub-form-item>
    </ipub-form>
    <div class="guestEditorSearch">
      <div class="ipub-p1 mar-b-10">Guest Editor</div>
      <div class="flex mar-b-30">
        <ipub-input v-model="guestEditorEmail"
                    style="width:300px;margin-right:20px"
                    placeholder="Search or create by Email" />
        <ipub-button type="primary"
                     class="ipub-p1 line-h-40"
                     @click="addGuestEditor"
                     icon="iconAdd"></ipub-button>
      </div>
      <ipub-table :columns="guestEditorColumns"
                  :pagination="false"
                  fixed
                  draggable
                  @drag="(e)=>{setSort(e,'editorList')}"
                  :dataSource="params.editorList">
        <template v-slot:name="{record}">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${record.firstName} ${record.lastName}`" />
        </template>
        <template v-slot:link="{text, record}">
          <a v-if="text"
             class="link-color omis"
             target="_blank"
             style="display:inline-block;width:100%"
             :href="`${domain}/${text}`">{{record.cvName}}</a>
          <template v-else>- -</template>
        </template>
        <template v-slot:actions="{ record, index }">
          <!-- <ipub-tooltip class="border-right"
                        placement="bottomRight"
                        action="click">
            <div style="font-size:14px;"
                 slot="title">
              <div class="flex ipub-c-p"
                   @click="createCanvans(record, 'ge-b')">
                <ipub-icon type="iconBanner" />
                Banner
              </div>
              <div class="flex ipub-c-p"
                   @click="createCanvans(record, 'ge-c')">
                <ipub-icon type="iconCertificate" />
                Certificate
              </div>
            </div>
            <ipub-icon type="iconGenerator" />
          </ipub-tooltip> -->
          <ipub-tooltip class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="editGuestEditor(record, index)" />
          </ipub-tooltip>
          <ipub-tooltip>
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="delGuestEditor(index)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <div class="plannedPaper"
         v-if="isApp">
      <div class="ipub-p1 line-h-40 relative mar-b-30">
        Planned Paper
        <div class="right-option">
          <ipub-button type="primary"
                       @click="addPlannedPaper"
                       icon="iconAdd">Add Paper</ipub-button>
        </div>
      </div>
      <ipub-table :columns="plannedPaperColumns"
                  :pagination="false"
                  :dataSource="params.particleList">
        <template v-slot:actions="{ record, index }">
          <ipub-tooltip class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="editPlannedPaper(record, index)" />
          </ipub-tooltip>
          <ipub-tooltip>
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="delPlannedPaper(index)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <div class="btns ipub-p1 line-h-40">
      <ipub-button type="primary"
                   plain
                   style="width:150px"
                   @click="$router.back(-1)">Cancel</ipub-button>
      <ipub-button type="primary"
                   style="width:150px"
                   @click="save()">Save</ipub-button>
      <template v-if="isApp">
        <ipub-button v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.APPLY.REFUSE')"
                     type="primary"
                     plain
                     style="width:150px"
                     @click="reject">Reject</ipub-button>
        <ipub-button v-if="user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.APPLY.ACCEPT')"
                     type="primary"
                     style="width:150px"
                     @click="accept">Accept</ipub-button>
      </template>
      <template v-else-if="!params.id&&user.codeList&&user.codeList.includes('WEBSITE.SPECIAL_ISSUES.PUBLISH')">
        <ipub-button type="primary"
                     style="width:150px"
                     @click="save('Publish')">Publish</ipub-button>
      </template>
    </div>
    <Add ref="guest-editor-add"
         :isVisable="isVisable"
         :inputData="inputData"
         :editors="params.editorList"
         @confirm="confirm"
         @cancel="cancel" />
    <AddPlannedPaper ref="planned-paper-add"
                     :isVisable="isVisablePlannedPaper"
                     :inputData="inputData"
                     @confirm="confirmPlannedPaper"
                     @cancel="cancel" />
    <SendEmail :isVisable="showSendEmail"
               :inputData="inputData"
               event="APPROVAL_OF_SPECIAL_ISSUE_APPLICATION"
               @cancel="cancel" />
    <CreatePNG :isVisable="isVisablePDF"
               :inputData="inputData"
               :type="pdfType"
               :journalId="params.journalId"
               @confirm="cancel"
               @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
